module.exports = __webpack_public_path__ + "static/media/favicon.7656a6d1.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/favicon.ico
// module id = 675
// module chunks = 0